import React, {useState} from 'react';
import {
  Typography,
  Accordion as Accord,
  AccordionSummary,
  AccordionDetails,
  Box,
  styled,
} from '@mui/material';
import {Card} from '@jobseeker/lotus/lib/components';
import {Minus, Plus} from '@jobseeker/lotus/lib/assets/icons';
import Image from 'next/image';

const Accordion = styled(Accord)(() => ({
  ':before': {
    height: '0px',
    borderBottom: '1px solid #7E7E7E20',
  },
  '.mui-style-1aemtkb-MuiAccordionDetails-root': {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
  '.Mui-expanded': {
    marginTop: '0px',
    marginBottom: '0px',
  },
}));

const FAQPage = () => {
  const DOMAIN = `${process.env.NEXT_PUBLIC_APP_DOMAIN}`;
  const [expandedIndex, setExpandedIndex] = useState<number>(-1);

  const toggleAccordion = (index: number) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1);
    } else {
      setExpandedIndex(index);
    }
  };

  const faqData = [
    {
      question: <>What is the {DOMAIN} Pro Membership Plan?</>,
      answer: (
        <>
          The {DOMAIN} Pro Membership plan is a paid service offered to
          candidates as a means to enhance their job search. It gives candidates
          access to the below mentioned premium features that are not available
          to free members:
          <ul>
            <li>
              Access to <b>&quot;Insights&quot;</b> - which helps you compare
              your application against all other applications received for a
              particular job
            </li>
            <li>
              A star icon against your application (to improve visibility)
            </li>
            <li>
              A unique ad free job search experience (devoid of all
              advertisements on the site)
            </li>
            <li>
              The ability to highlight jobs that are posted directly by
              employers
            </li>
            <li>
              The ability to view your status against already applied jobs
            </li>
          </ul>
        </>
      ),
    },
    {
      question: <>What are charges and validity periods for the above plan?</>,
      answer: <>Rs. 2000 - Valid for 6 months from the date of purchase.</>,
    },
    {
      question: <>How can I make a payment for this service?</>,
      answer: (
        <>
          Please login to your account and under the dropdown menu (top right
          corner), you&apos;ll see an &quot;Upgrade&quot; button.
        </>
      ),
    },
    {
      question: (
        <>
          Does buying the Pro Membership Plan guarantee me an interview call or
          access to exclusive jobs?
        </>
      ),
      answer: (
        <>
          No and we don&apos;t make any such claims. Buying the Pro Membership
          plan does not mean that we will find jobs or follow up with the
          recruiters on your behalf. Similarly, we don&apos;t guarantee
          interview calls or jobs because that rests solely in the hands of the
          hiring manager.
          <br />
          The Pro Membership Plan simply offers you access to additional,
          beneficial product features that aren&apos;t available to basic (free)
          members.
        </>
      ),
    },
  ];

  return (
    <Box
      sx={{
        maxWidth: '1050px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card variant="" heading="">
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '30px',
            textAlign: 'Center',
            color: 'secondary.dark',
            marginBottom: '40px',
          }}
        >
          FREQUENTLY ASKED QUESTIONS
        </Typography>

        {faqData.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expandedIndex === index}
            onChange={() => toggleAccordion(index)}
            sx={{
              border: 'none',
              background: '#FFFFFF',
              boxShadow: 'none',
              borderBottom:
                expandedIndex === index ? 'none' : '1px solid #7E7E7E20',
            }}
          >
            <AccordionSummary
              expandIcon={
                expandedIndex === index ? (
                  <Image src={Minus} alt={'-'} width={12} height={12} />
                ) : (
                  <Image src={Plus} alt={'+'} width={12} height={12} />
                )
              }
              aria-controls={`panel${index + 1}a-content`}
              id={`panel${index + 1}a-header`}
              sx={{
                border: 'none',
                background: '#FFFFFF',
                '& .MuiAccordionSummary-content': {
                  border: 'none',
                },
              }}
            >
              <Typography
                sx={{
                  color: 'primary.main',
                  fontWeight: 600,
                  fontSize: '16px',
                }}
              >
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{borderBottom: 'none'}}>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 500,
                }}
              >
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Card>
    </Box>
  );
};

export default FAQPage;
